import GState from "./__GState";
import ZArray from "./ZArray";
import _ from "lodash";
import { toJS } from "mobx";
import axios from "axios";
import LocaleX from "./LocaleX";
import LogicX from "./LogicX";
import NavX from "./NavX";
import AtthExpress from "IZOX/ARCS/API/AtthExpress";
import { DOMAIN, SITEBASE } from "__SYSDefault/Domain";
import fileDownload from "js-file-download";
import ReqX from "./ReqX";
import { SysConfig } from "__SYSDefault/Config";
import RegFunc from "./RegFunc";

class GFunc {

  /**
   * @typedef {import("IZOX/__Typedef/common").lang} lang  
   * @typedef {import("IZOX/__Typedef/common").sysuserstatus} sysuserstatus
   */

  /**
   * 
   * @param {*} payload 
   * @returns 
   */
  static Login(payload){
    if(!LogicX.CheckAllValid(payload, ["JWT", "userProfile"], 
      (value) => !_.isEmpty(value))){
      return {Success: false};
    }
    GState.setLogged(true);
    GState.setUser(payload);
    return {Success: true};
  }

  /**
   * 
   */
  static Logout(){
    GState.clearUser();
    GState.setLogged(false);
  }

  /**
   * 
   * @param {Boolean} tf 
   */
  static Loading(tf){
    RegFunc.Exec("Loading", tf);
  }

  /**
   * 
   * @param {*} payload 
   */
  static Refresh(payload){
    let user = GState.user;
    user.userProfile = payload.userProfile;
    GState.setUser(user);
  }

  /**
   * 
   * @returns 
   */
  static GetJWT(){
    return toJS(GState.user?.JWT);
  }

  /**
   * @returns {sysuserstatus}
   */
  static GetUserStatus(){
    return toJS(GState.user?.userProfile?.status);
  }

  /**
   * 
   * @returns {String[]}
   */
  static GetUserRoles(){
    return toJS(GState.user?.userProfile?.roles);
  }

  /**
   * Get user permission, scope SYS
   * @returns 
   */
  static GetUserSYSAuth(){
    return toJS(GState.user?.userProfile?.SYSAuth);
  }

  /**
   * 
   * @returns 
   */
  static GetUserProfile(){
    return toJS(GState.user?.userProfile) ?? null;
  }

  static Save(key, value){
    GState.UPDATE(`save_${key}`, value);
  }

  static Load(key){
    return GState[`save_${key}`];
  }

  static PersistSave(key, value){
    let keys = [];
    if(_.isArray(GState.persistKeys)){
      keys = GState.persistKeys ?? [];
    }
    if(!keys.includes(`save_${key}`)) keys.push(`save_${key}`);
    GState.UPDATE("persistKeys", keys);
    GState.UPDATE(`save_${key}`, value);
  }

  static PersistClear(key){
    let keys = [];
    if(_.isArray(GState.persistKeys)){
      keys = GState.persistKeys ?? [];
    }
    if(keys.includes(`save_${key}`)) keys = _.filter(keys, o => o !== `save_${key}`);
    GState.UPDATE("persistKeys", keys);
    GState.UPDATE(`save_${key}`, null);
  }

  /**
   * 
   * @returns 
   */
  static GetSELFUserID(){
    return toJS(GState.user?.userProfile?._id) ?? null;
  }

  /**
   * 
   * @returns 
   */
  static GetUserDisplayName(){
    return this.GetUserProfile()?.userDisplayName ?? "";
  }

  /**
   * 
   * @returns 
   */
  static GetUserPhoto(){
    return this.GetUserProfile()?.userPhoto ?? "";
  }

  /**
   * 
   * @returns 
   */
  static onlyUsernamePassword(){
    let {server} = GState;
    return  (!_.isArray(server?.Authentication) && server?.Authentication === "Username-Password") 
      || (_.isArray(server?.Authentication) 
        && server?.Authentication.length === 1 
        && server?.Authentication[0] === "Username-Password");
  }

  /**
   * 
   * @param {lang | lang[]} message 
   * @param {"info" | "system" | "warn" | "warning" | "success" | "error" } severity 
   * @param {String} join
   */
  static Alert(message, severity = "info", join = "", duration = undefined){
    if(process?.env?.NODE_ENV === "production" &&
      SysConfig.preventErrorAlert && severity === "system"){
      console.error(message);
      return;
    }else if(severity === "system"){
      severity = "error";
    }
    message = ZArray.Ensure(message);
    message = _.map(message, o => LocaleX.Parse(o)).join(join);
    RegFunc.Exec("OpenSnack", {
      message,
      severity,
      duration
    });
  }

  /**
   * 
   */
  static CloseAlert(){
    RegFunc.Exec("CloseSnack");
  }

  /**
   * @typedef {import("IZOX/BLOCKS/Libs/OperBar/OperBar").btnType} btnType
   * 
   * @typedef {Object} askqparams
   * * @property {Function} [onConfirm] - Callback function when confirmed.
   * * @property {Function} [onCancel] - Callback function when cancelled.
   * * @property {Function} [onInvalid] - Callback function when input is invalid.
   * * @property {Boolean} [autoClose] - Whether to close the ask dialog automatically after confirmation.
   * * @property {Boolean} [showCloseIcon] - Whether to show the close icon on the ask dialog.
   * * @property {String} [join] - String to join multiple messages.
   * * @property {btnType[]} [buttons] - Array of button labels to display.
   * * @property {Boolean} [isLoading] - Whether the ask dialog is in loading state.
   * * @property {*} [inner] - Function to render custom content inside the ask dialog.
   * 
   * @param {lang | lang[]} title 
   * @param {lang | lang[]} message
   * @param {askqparams} [param0]
   */
  static AskQ(title, message = "", {
    onConfirm = null, 
    onCancel = null, 
    onInvalid = null,
    autoClose = true, 
    showCloseIcon = false, 
    join = "",
    buttons = ["No", "Yes"],
    isLoading = false,
    inner
  } = {}){
    title = ZArray.Ensure(title);
    title = _.map(title, o => LocaleX.Parse(o)).join();
    message = ZArray.Ensure(message);
    message = _.map(message, o => LocaleX.Parse(o)).join(join);
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      RegFunc.Exec("OpenDialog", {
        title, 
        message,
        onConfirm,
        onCancel,
        onInvalid,
        buttons,
        showCloseIcon,
        isLoading,
        autoClose,
        inner
      });
    }, 100);
  }

  /**
   * 
   * @param {lang | lang[]} message 
   * @param {Function} onConfirm 
   */
  static AskConfirm(message, onConfirm){
    this.AskQ({
      EN: "Confirm to operate?",
      TC: "確認操作?"
    }, message, {
      onConfirm,
      buttons: ["Cancel", "Confirm"]
    });
  }

  /**
   * 
   * @param {lang | lang[]} title 
   * @param {lang | lang[]} message 
   * @param {Function} onConfirm 
   * @param {Function} onCancel 
   * @param {Boolean} autoClose 
   * @param {Boolean} showCloseIcon 
   * @param {String} join
   */
  static AskYesNo(title, message = "", onConfirm = null, onCancel = null, autoClose = true, showCloseIcon = false, join = ""){
    this.AskQ(title, message, {
      onConfirm,
      onCancel,
      autoClose,
      showCloseIcon,
      join,
      buttons: ["No", "Yes"]
    });
  }

  /**
   * 
   * @param {lang | lang[]} title 
   * @param {lang | lang[]} message 
   * @param {Function} onConfirm 
   * @param {Function} onCancel 
   * @param {Boolean} autoClose 
   * @param {Boolean} showCloseIcon 
   * @param {String} join
   */
  static Ask(title, message = "", onConfirm = null, onCancel = null, autoClose = true, showCloseIcon = false, join = ""){
    this.AskQ(title, message, {
      onConfirm,
      onCancel,
      autoClose,
      showCloseIcon,
      join,
      buttons: ["Cancel", "Confirm"],
    });
  }

  /**
   * 
   * @param {lang | lang[]} title 
   * @param {lang | lang[]} message 
   * @param {[{
   *  func: Function,
   *  icon: React.JSX,
   *  content: String,
   *  theme: *
   * }]} buttons 
   * @param {Boolean} showCloseIcon
   * @param {String} join
   */
  static AskFor(title, message = "", buttons, showCloseIcon = false, join = ""){
    this.AskQ(title, message, {
      buttons,
      showCloseIcon,
      join
    });
  }

  /**
   * 
   * @param {Boolean} tf 
   */
  static SetAskLoading(tf){
    RegFunc.Exec("SetDialogLoading", tf);
  }

  /**
   * 
   */
  static CloseAsk(){
    RegFunc.Exec("CloseDialog");
  }

  /**
   * 
   * @param {lang | lang[]} title 
   * @param {*} message 
   * @param {Function} inner 
   * @param {Function} onConfirm 
   * @param {Function} onCancel 
   * @param {String} join
   */
  static Form(title, message = "", inner = null, onConfirm = null, onCancel = null, onInvalid = null){
    this.AskQ(title, message, {
      onConfirm,
      onCancel,
      onInvalid,
      inner,
      buttons: [],
      showCloseIcon: true,
    });
  }

  /**
   * 
   * @param {lang | lang[]} title 
   * @param {lang | lang[]} message 
   * @param {Function} onConfirm 
   * @param {String} join
   */
  static Pop(title, message = "", onConfirm = null, join = ""){
    this.AskQ(title, message, {
      onConfirm,
      join,
      buttons: ["OK"],
    });
  }

  /**
   * @typedef {import("IZOX/BLOCKS/Libs/OperBar/OperBar").operbtns} operbtns
   * 
   * @param {lang | lang[]} title 
   * @param {lang | lang[]} message 
   * @param {operbtns[]} buttons
   */
  static PopCustom(title, message = "", buttons = undefined, join = ""){
    this.AskQ(title, message, {
      buttons: buttons ?? ["OK"],
      join,
    });
  }

  /**
   * 
   */
  static ClosePop(){
    RegFunc.Exec("CloseDialog");
  }

  /**
   * 
   * @param {(addOns) => JSX.Element} backdrop 
   * @param {*} addOns 
   * @param {Boolean} closeOutside
   * @param {Boolean} closeButton
   * @param {Boolean} noBG
   * @param {Function} onClose
   */
  static Backdrop(backdrop, addOns, closeOutside = true, closeButton = false, noBG = false, onClose = null){
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      RegFunc.Exec("OpenBackdrop", {
        render: backdrop, 
        addOns: addOns,
        closeOutside: closeOutside,
        closeButton: closeButton,
        noBG: noBG,
        onClose: onClose
      });
    }, 100);
  }

  /**
   * 
   */
  static CloseBackdrop(){
    RegFunc.Exec("CloseBackdrop");
  }

  /**
   * 
   * @param {(addOns) => JSX.Element} backdrop 
   * @param {*} addOns 
   * @param {Boolean} closeOutside
   * @param {Boolean} closeButton
   * @param {Boolean} noBG
   * @param {Function} onClose
   */
  static Modal(backdrop, addOns, closeOutside = true, closeButton = false, noBG = false, onClose = null){
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      RegFunc.Exec("OpenModal", {
        render: backdrop, 
        addOns: addOns,
        closeOutside: closeOutside,
        closeButton: closeButton,
        noBG: noBG,
        onClose: onClose
      });
    }, 100);
  }

  /**
   * 
   */
  static CloseModal(){
    RegFunc.Exec("CloseModal");
  }

  /**
   * 
   * @param {(addOns) => JSX.Element} backdrop 
   * @param {*} addOns 
   * @param {Boolean} closeOutside
   * @param {Boolean} closeButton
   * @param {Boolean} noBG
   * @param {Function} onClose
   */
  static SelectorOverlay(backdrop, addOns, closeOutside = true, closeButton = false, noBG = false, onClose = null){
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      RegFunc.Exec("OpenSelectorOverlay", {
        render: backdrop, 
        addOns: addOns,
        closeOutside: closeOutside,
        closeButton: closeButton,
        noBG: noBG,
        onClose: onClose
      });
    }, 0);
  }

  /**
   * 
   */
  static CloseSelectorOverlay(){
    RegFunc.Exec("CloseSelectorOverlay");
  }

  /**
   * 
   */
  static toggleMini(){
    GState.setMini(!GState.mini);
  }

  /**
   * 
   * @param {String | String[]} src 
   * @param {{
   *  activeIndex: Number,
   *  zIndex: Number,
   *  drag: Boolean,
   *  attribute: Boolean,
   *  zoomable: Boolean,
   *  rotatable: Boolean,
   *  scalable: Boolean,
   *  onMaskClick: Function,
   *  downloadable: Boolean,
   *  noClose: Boolean,
   *  noNavbar: Boolean,
   *  noToolbar: Boolean,
   *  noImgDetails: Boolean,
   *  noFooter: Boolean,
   *  changeable: Boolean,
   *  customToolbar: (defaultToolbarConfigs: import("react-viewer/lib/ViewerProps").ToolbarConfig[]) => ToolbarConfig[])
   *  zoomSpeed: Number,
   *  defaultSize: import("react-viewer/lib/ViewerProps").ViewerImageSize,
   *  defaultImg: import("react-viewer/lib/ViewerProps").ViewerDefaultImg,
   *  disableKeyboardSupport: Boolean,
   *  noResetZoomAfterChange: Boolean,
   *  noLimitInitializationSize: Boolean,
   *  defaultScale: Number,
   *  onChange: (activeImage: import("react-viewer/lib/ViewerProps").ImageDecorator, index: number) => void,
   *  loop: Boolean,
   *  disableMouseZoom: Boolean,
   *  downloadInNewWindow: Boolean,
   *  className: String,
   *  showTotal: Boolean,
   *  maxScale: Number,
   *  minScale: Number
   * }} option 
   */
  static ViewImage(src, option, closeOnMaskClick = true, onClose = null){
    src = ZArray.Ensure(src);
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      RegFunc.Exec("OpenViewer", {
        images: _.map(src, o => ({src: o, alt: ""})),
        closeOnMaskClick: closeOnMaskClick,
        props: {
          activeIndex: 0,
          zIndex: 1000,
          drag: true,
          attribute: true,
          zoomable: true,
          rotatable: true,
          scalable: true,
          downloadable: false,
          noClose: false,
          noNavbar: false,
          noToolbar: false,
          noImgDetails: false,
          noFooter: false,
          changeable: false,
          zoomSpeed: 0.2,
          disableKeyboardSupport: false,
          noResetZoomAfterChange: false,
          noLimitInitializationSize: false,
          defaultScale: 1,
          loop: true,
          disableMouseZoom: false,
          downloadInNewWindow: false,
          showTotal: true,
          maxScale: 10,
          minScale: 0.1,
          ...option
        },
        onClose: onClose
      });
    }, 100);
  }

  /**
   * @typedef {import("IZOX/__Typedef/common").izoxatth} izoxatth
   * 
   * @param {izoxatth} file 
   * @returns 
   */
  static async ViewIZOXImage(file){
    let {refID, complete, oriFile, type, blob} = file;

    if(blob) refID = blob;

    if(!_.isEmpty(refID) && !refID.startsWith("izox::")){
      if(refID.startsWith("http")){
        this.ViewImage(`${refID}`);
      }else{
        this.ViewImage(`${SITEBASE}/${refID}`);
      }
      return;
    }

    if(type?.startsWith("image/")){
      if(refID || complete >= 100){
        let res = await AtthExpress.GetBlobUrl(refID);
        let {url} = res;
        if(!url?.startsWith("http")){
          url = `${DOMAIN}${url?.slice(1)}`;
        }
        this.ViewImage(url);
      }else{
        if(oriFile){
          let url = URL.createObjectURL(oriFile);
          this.ViewImage(url);
        }
      }
      return;
    }

    if(refID || complete >= 100){
      let res = await AtthExpress.GetBlobUrl(refID);
      window.open(res.url);
    }else{
      if(oriFile){
        let url = URL.createObjectURL(oriFile);
        window.open(url);
      }
    }
  }

  /**
   * 
   * @param {String} url 
   */
  static async PreviewPDF(url){
    let res = await axios.get(url, {responseType: "blob"});
    let blob = new Blob([res.data], {type: "application/pdf"});
    let blobURL = URL.createObjectURL(blob);
    window.open(blobURL);
  }

  /**
   * 
   * @param {String} url 
   * @param {String} type 
   * @returns 
   */
  static async Preview(url, type = ""){
    console.log("Preview", url, type);
    if(_.isEmpty(url)){
      this.Alert({
        EN: "File not found",
        TC: "找不到檔案"
      }, "warn");
      return;
    }
    if(type.includes("image")){
      this.ViewImage(url);
    }else if(type?.includes("pdf")){
      this.PreviewPDF(url);
    }else{
      window.open(url);
    }
  }

  /**
   * 
   * @param {String} serviceID 
   * @returns 
   */
  static GetACLibDocs(serviceID){
    return toJS(GState.projDetails?.acLibs?.[serviceID]) ?? [];
  }

  /**
   * 
   * @param {String} serviceID 
   * @param {String} aclibID 
   * @returns 
   */
  static GetACLib(serviceID, aclibID){
    let allLibDocs = this.GetACLibDocs(serviceID);
    let aclib = _.find(allLibDocs, o => o._id === aclibID);
    return aclib?.libs ?? [];
  }

  /**
   * 
   * @param {String} serviceID 
   * @param {String} aclibID 
   * @param {String} valueID 
   * @returns 
   */
  static GetACLibValue(serviceID, aclibID, valueID){
    let libs = this.GetACLib(serviceID, aclibID);
    let value = _.find(libs, o => o.val === valueID);
    return value ?? null;
  }

  /**
   * 
   * @param {String} url 
   * @param {String} fileType 
   * @returns 
   */
  static openAssetInNewPage = async (url, fileType) => {
    try {
      await axios
        .get(url, {
          responseType: "blob",
          params: {},
        })
        .then((response) => {
          const file = new Blob([response.data], { type: fileType });
          const fileURL = URL.createObjectURL(file);
          const pdfWindow = window.open();
          pdfWindow.location.href = fileURL;            
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      return { error };
    }
  }

  /**
   * 
   * @param {String} url 
   * @param {String} fileName 
   */
  static async Download(url, fileName){
    let _src = url;
    if(_.isArray(url) && url.length > 0){
      _src = url[0];
    }

    if(!_.isString(_src)){
      if(_src.refID){
        if(_src.refID.startsWith("izox::")){
          if(!_.isEmpty(fileName)){
            let res = await AtthExpress.GetBlobNoAuth(_src.refID);
            fileDownload(res.blob, `${fileName}.${_src.ext}`);
          }else{
            let res = await AtthExpress.GetBlobUrl(_src.refID);
            NavX.NewWindow(res.url);
          }
        }else{
          NavX.NewWindow(_src.refID);
        }
      }else{
        NavX.NewWindow(_src);
      }
    }else{
      if(_src?.startsWith("izox::")){
        let res = await AtthExpress.GetBlobUrl(_src);
        NavX.NewWindow(res.url);
      }else{
        NavX.NewWindow(_src);
      }
    }
  }

  /**
   * 
   * @param {String} path 
   */
  static async DownloadByTruePath(path){
    let res = await ReqX.SendBE("/CMS/Blob/GetSASByTruePath", {
      truepath: path
    });
    if(res.Success){
      let blobURL = res.payload;
      window.open(blobURL);
    }else{
      this.Alert("Failed to download file", "error");
    }
  }

  static GetCurrentPageInfo(){
    return {
      href: window.location.href,
      search: window.location.search,
      pathname: window.location.pathname,
      title: document.title,
      referrer: document.referrer,
      hostname: window.location.hostname,
      meta: GState.currentPageInfo
    };
  }

}

export default GFunc;